import { PlusIcon } from '@heroicons/react/24/outline'
import clsx from 'clsx'
import { useId, useState } from 'react'

import { LINKS } from '../../../bewerbende/copy'
import { useCopy } from '../../../i18n'

export const FAQ_PARTICLES = [
  [0, () => ({ type: 'scatter', alpha: 0.2, seed: 71 })],
  [1, () => ({ type: 'scatter', alpha: 0.2, seed: 73 })]
]

// Glas-Akkordeon, die Section scrollt normal. Die erste Frage ist offen
export default function CsFaq() {
  const c = useCopy('faq')
  const [open, setOpen] = useState(0)
  const base = useId()

  return (
    <div className='cs-faq'>
      <h2 className='sc-h2'>{c.title}</h2>
      <div className='cs-faq__list'>
        {c.items.map((item, i) => {
          const isOpen = open === i
          const id = `${base}-${i}`
          return (
            <div
              key={item.q}
              className={clsx('cs-faq__item sc-glass', isOpen && 'is-open')}
            >
              <h3>
                <button
                  type='button'
                  className='cs-faq__q'
                  aria-expanded={isOpen}
                  aria-controls={id}
                  onClick={() => setOpen(isOpen ? -1 : i)}
                >
                  {item.q}
                  <PlusIcon className='cs-faq__icon' />
                </button>
              </h3>
              <div
                id={id}
                role='region'
                className='cs-faq__a'
                aria-hidden={!isOpen}
              >
                <div>
                  <p>{item.a}</p>
                </div>
              </div>
            </div>
          )
        })}
      </div>
      <a
        className='cs-faq__privacy'
        href={LINKS.privacy}
        target='_blank'
        rel='noreferrer'
      >
        {c.privacy}
      </a>
    </div>
  )
}
